import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'notificacao',
  templateUrl: './alerta-notificacao.component.html',
  styleUrls: ['./alerta-notificacao.component.scss']
})
export class AlertaNotificacaoComponent implements OnInit {

  @Input() mensagem: String;
  @Input() tempo: Number = 3000;
  @Input() tipo: String = "success";

  @Output() carregar = new EventEmitter();
  @Output() sair = new EventEmitter();


  animation: String = 'animated bounceIn';

  visivel = false;

  constructor() { }

  ngOnInit() {

  }

  mostra(mensagem, tipo) {
    this.visivel = true; 
    this.mensagem = mensagem;
    this.tipo = tipo;
    this.animation = 'animated bounceIn';
     setTimeout(() => {
      this.animation = 'animated bounceOut';
      setTimeout(() => {
        this.visivel = false; 
        this.onClose(this)
      }, 2000);
    }, this.tempo);
  }

  onClose(alert) {
    this.sair.emit(alert);
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/alerta-notificacao/alerta-notificacao.component.ts